import { createAsyncThunk } from "@reduxjs/toolkit";
import { CaseStagesAPI, CaseStageConfig, AddStageRequest, SaveCaseStageResponse } from "../../../api/caseStages";

export const fetchStageConfigs = createAsyncThunk<
  CaseStageConfig[],
  void,                 
  { rejectValue: string }
>(
  "caseStageConfigs/fetchStageConfigs",
  async (_, { rejectWithValue }) => {
    try {
      const response = await CaseStagesAPI.get_configs();
      return response.stage_configs; 
    } catch (error) {
      return rejectWithValue("Failed to fetch stage configs");
    }
  }
);

interface UpdateCaseStageArgs {
  caseId: string;
  request: AddStageRequest;
}

export const updateCaseStage = createAsyncThunk<
  SaveCaseStageResponse,
  UpdateCaseStageArgs,
  { rejectValue: string }
>(
  "caseStages/updateCaseStage",
  async ({ caseId, request }, { rejectWithValue }) => {
    try {
      const response = await CaseStagesAPI.add(caseId, request);
      return response;
    } catch (error) {
      return rejectWithValue("Failed to update case stage");
    }
  }
);